import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';

import api from './middleware/api';
import cTaskAnswer from './middleware/cTaskAnswer';

import createRootReducer from './reducer';
import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "./services/baseApi";

// Создаём context
const { createReduxHistory, routerMiddleware, routerReducer } =
    createReduxHistoryContext({ history: createBrowserHistory() });

export const store = configureStore({
    reducer: createRootReducer(routerReducer),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredPaths: ["router"],
            },
        }).concat(
            routerMiddleware,
            baseApi.middleware,
            api, // старое middleware
            cTaskAnswer
        ),
    devTools: false,
});

// Экспортируем history для роутера
export const history = createReduxHistory(store);

export default store;
